import type { RoomOccupancy } from '@/domain/shared/types'
import { Button } from '@sunwebgroup/uds-ui/button'
import cn from 'classnames'
import { Fragment, use } from 'react'
import { useIntl } from '@/intl'
import { CatalogueDetailsContext } from '@/scopes/common/components/CatalogueDetailsContext'
import * as ParticipantsFilterPrimitive from '@/scopes/common/components/Filters/Participants'
import Room from '@/scopes/common/components/Filters/Participants/Room'
import styles from './index.module.css'
import { useRoomsParticipantsDistributionStore } from './useParticipantsStore'

const MAX_ROOMS = 10

export function AddRoomsButton() {
  const intl = useIntl()
  const { roomsParticipantDistribution, addRoom } = useRoomsParticipantsDistributionStore()
  const maxRoomLimitReached = roomsParticipantDistribution.length >= MAX_ROOMS
  const { isWinter } = use(CatalogueDetailsContext)
  return (
    <Button
      fullWidth
      variant="secondary"
      disabled={maxRoomLimitReached}
      onClick={addRoom}
      data-qa="add-room-button"
    >
      {intl.formatMessage({
        id: isWinter ? 'quicksearch_filter_participants_add_apartment' : 'quicksearch_filter_participants_add_room',
      })}
    </Button>
  )
}

export function Footer({ className, children }: React.PropsWithChildren<{ className?: string }>) {
  return <div className={cn(styles.footer, className)}>{children}</div>
}

export function DialogBannerWrapper({ className, children }: React.PropsWithChildren<{ className?: string }>) {
  return <div className={cn(styles.dialogBannerWrapper, className)}>{children}</div>
}

// Hardcoded for now, this should come from sitecore

export function Body({ className, isMultiRoom = true }: { className?: string, isMultiRoom?: boolean }) {
  const { roomsParticipantDistribution } = useRoomsParticipantsDistributionStore()
  return (
    <div className={cn(styles.content, className)}>
      {roomsParticipantDistribution.map((_: RoomOccupancy, roomIndex: number) => (
        <Fragment key={roomIndex}>
          <Room roomIndex={roomIndex} />
        </Fragment>
      ))}
      {isMultiRoom && <ParticipantsFilterPrimitive.AddRoomsButton />}
    </div>
  )
}
